module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('h3', [_vm._v("Hire Invoice")]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Client Name: " + _vm._s(_vm.clientName))]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Contract Series:" + _vm._s(_vm.clientSeries))])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "viewSalesBooking"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Invoice Month")]), _vm._v(" "), _c('th', [_vm._v("No of days")]), _vm._v(" "), _c('th', [_vm._v("View Invoice")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientListView), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.month) + " , " + _vm._s(item1.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.days[index]))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewInvoice(item1.month1, item1.year, _vm.days[index])
        }
      }
    }, [_c('md-icon', [_vm._v("visibility")])], 1)], 1)])
  }))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d866e8f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/listView/viewHireInvoice.vue
// module id = 2877
// module chunks = 0